import type { Paginated } from '@partou/core';
import { inject, Injectable } from '@angular/core';
import { PaginatedSelectStore, type PaginatedSelectRequest } from '@partou/core';
import { type Observable } from 'rxjs';
import type { Location } from '../types';
import { LocationsApiService } from '../services/locations.api';

@Injectable()
export class LocationsSelectStore extends PaginatedSelectStore<Location> {
  constructor() {
    const api: LocationsApiService = inject(LocationsApiService);
    super(
      (request: PaginatedSelectRequest): Observable<Paginated<Location>> =>
        api.getLocations({ nameSearch: request.searchTerm, limit: request.limit, offset: request.offset }),
    );
  }
}
